import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	ZAxis,
	ScatterChart,
	Scatter,
	Label,
	LabelList,
	ReferenceLine,
	Tooltip,
} from "recharts";
import React, { useState, useEffect } from "react";
import { numberFormatter } from "../../utils";
const GrossMarginChart1 = (props: any) => {
	const [data, setData] = useState([]);
	const refX = props?.performanceGraphData?.weightedCagr * 100;
	const refY = props?.performanceGraphData?.weightedGM * 100;
	const { selectedMaskStatus, supplier, selectedVendor } = props;
	console.log(supplier, "suuplier");
	useEffect(() => {
		if (props?.performanceGraphData) {
			setData(props.performanceGraphData?.peer);
		}
	}, [props]);
	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Supplier:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.peer_vendor_name}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Spend:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.invCost, 0, "$")}
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								5 Year CAGR:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cagr, 0)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Last Year Gross Margin %:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.gm, 0)}%
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	return (
		<div className="w-full flex flex-col items-center h-[80%]  p-1">
			<ResponsiveContainer width="100%" height="100%">
				<ScatterChart
					width={400}
					height={400}
					margin={{
						top: 30,
						right: 70,
						bottom: 10,
						left: 30,
					}}
				>
					<XAxis
						className="graph-label "
						stroke="black"
						type="number"
						dataKey="cagr"
						tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
						domain={["dataMin - 5", "dataMax + 5"]}
					>
						<Label
							value="5 Year CAGR"
							offset={-1}
							position="bottom"
							style={{ fill: "black" }}
						/>
					</XAxis>
					<YAxis
						className="graph-label "
						stroke="black"
						type="number"
						dataKey="gm"
						interval={0}
						tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
						domain={["dataMin - 5", "dataMax + 5"]}
					>
						<Label
							value={`LYGM%​`}
							angle={-90}
							offset={0}
							position="insideLeft"
							style={{ fill: "black", textAnchor: "middle" }}
						/>
					</YAxis>

					<ZAxis
						type="number"
						dataKey="invCost"
						range={data?.length <= 10 ? [100, 1000] : [50, 200]}
					></ZAxis>
					<ReferenceLine
						x={refX}
						label={{
							position: "top",
							fill: "#ce9178",
							value: numberFormatter(refX, 2) + "%",
							fontStyle: "italic",
							className: 'textMedium'
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>
					<ReferenceLine
						y={refY}
						label={{
							position: "right",
							fill: "#ce9178",
							value: numberFormatter(refY, 2) + "%",
							fontStyle: "italic",
							className: 'textMedium'
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>
					<Tooltip
						contentStyle={{
							color: "black",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#" }}
						content={customTooltip}
					/>
					{data?.map((d: any, index: number) => {
						return (
							<>
								{supplier?.includes(d?.peer_vendor_name) && (
									<Scatter
										key={index}
										data={[d]}
										fill={
											d?.peer_vendor_name ===
											selectedVendor?.master_vendor_name
												? "#62B5E582" // New blue color with alpha
												: "#EAA61482" // New yellow color with alpha
										}
									>
										{!selectedMaskStatus && (
											<LabelList
												dataKey="peer_vendor_name"
												fill="black"
												className="graph-label-xsmall"
												position={"right"}
											/>
										)}
									</Scatter>
								)}
							</>
						);
					})}
				</ScatterChart>
			</ResponsiveContainer>
		</div>
	);
};
export default GrossMarginChart1;
